if (!customElements.get('gemlay-sticky-atc')) {
  customElements.define('gemlay-sticky-atc', class GemlayStickyAtc extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      this.priceSource = document.getElementById(`price-${this.sectionId}`);
      this.button = this.querySelector('[data-sticky-button]');
      this.price = this.querySelector('[data-sticky-price]');
      if (!this.mainButton || !this.button) return;

      this.button.addEventListener('click', () => {
        if (!this.mainButton.disabled && this.mainButton.getAttribute('aria-disabled') !== 'true') this.mainButton.click();
      });

      this.sync = this.sync.bind(this);
      this.sync();

      this.buttonObserver = new MutationObserver(this.sync);
      this.buttonObserver.observe(this.mainButton, { attributes: true, childList: true, subtree: true });
      if (this.priceSource) {
        this.priceObserver = new MutationObserver(this.sync);
        this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, attributes: true });
      }

      this.intersection = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const buttonAboveViewport = entry.boundingClientRect.top < 0;
        this.toggleAttribute('hidden', entry.isIntersecting || !buttonAboveViewport);
      }, { threshold: 0.05 });
      this.intersection.observe(this.mainButton);
    }

    sync() {
      const disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
      this.button.disabled = disabled;
      const mainText = this.mainButton.querySelector('span:not(.sold-out-message)');
      if (mainText && mainText.textContent.trim()) this.button.textContent = mainText.textContent.trim();

      if (this.priceSource && this.price) {
        const sale = this.priceSource.querySelector('.price__sale .price-item--sale');
        const regular = this.priceSource.querySelector('.price__regular .price-item--regular');
        const source = sale && getComputedStyle(sale.closest('.price__sale')).display !== 'none' ? sale : regular;
        if (source) this.price.textContent = source.textContent.trim();
      }
    }

    disconnectedCallback() {
      this.buttonObserver?.disconnect();
      this.priceObserver?.disconnect();
      this.intersection?.disconnect();
    }
  });
}
